module.exports = __webpack_public_path__ + "img/users-logo.df431c01.svg";